export default (entities, newEntities) => {
  const transformedEntities = newEntities.reduce((acc, entity) => ({
    ...acc,
    [entity.id]: entity
  }), {})

  return {
    ...entities,
    ...transformedEntities
  }
}
